import { Image } from '@cian/ui-kit';
import { IconActionChevronLeft16, IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import cn from 'clsx';
import { isEmpty } from 'ramda';
import * as React from 'react';

import * as styles from './styles.css';
import { OfferGalleryEmpty } from '../OfferGalleryEmpty';

interface IOfferGalleryProps {
  images?: string[] | null;
  onScroll(): void;
  onClick(): void;
}

export const OfferGallery: React.VFC<IOfferGalleryProps> = ({ images, onScroll, onClick }) => {
  const galleryRef = React.useRef<HTMLDivElement>(null);

  const handleScroll = React.useCallback<React.MouseEventHandler<HTMLDivElement>>(e => {
    const galleryDiv = galleryRef.current as HTMLDivElement;
    const direction = e.currentTarget.dataset.direction as string;
    const width = galleryDiv.getBoundingClientRect().width * Number(direction);

    galleryDiv.scrollBy({ left: width, behavior: 'smooth' });
  }, []);

  if (!images || isEmpty(images)) {
    return (
      <div className={styles['container']}>
        <OfferGalleryEmpty />
      </div>
    );
  }

  return (
    <div className={styles['container']}>
      <div ref={galleryRef} className={styles['scroll']} onScroll={onScroll}>
        {images.map(url => (
          <div key={url} className={styles['image']}>
            <Image
              src={url}
              alt=""
              objectFit={'cover'}
              width="100%"
              height="100%"
              preloader
              onClick={onClick}
              display="block"
            />
          </div>
        ))}
      </div>
      <div onClick={handleScroll} data-direction="-1" className={cn(styles['arrow'], styles['arrow-left'])}>
        <IconActionChevronLeft16 display="block" />
      </div>
      <div onClick={handleScroll} data-direction="1" className={cn(styles['arrow'], styles['arrow-right'])}>
        <IconActionChevronRight16 display="block" />
      </div>
    </div>
  );
};
